

export function dashboard(state = {}, action) {
  switch (action.type) {
    case "FETCH_CUSTOMER_COUNT":
      return {
        ...state,
        totalCustomer: action.payload.data.totals.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      };
    case "FETCH_PRODUCT_COUNT":
      return {
        ...state,
        totalProduct: action.payload.data.totals.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      };
    case "FETCH_CHART_DATA":
      return {
        ...state,
        chartData: action.payload,
        chartMeta: action.payload.meta,
      };
    case "FETCH_EXCEL_DATA":
      return {
        ...state,
        report: action.payload
      };
    case "FETCH_PRODUCT_REPORT":
      return {
        ...state,
        productReport: action.payload
      };
    case "PRODUCT_PIE_DATA":
      return {
        ...state,
        pieData: action.payload
      };

    case "FETCH_BROADCAST":
      return {
        ...state,
        broadcastReport: action.payload
      };

    case "BROADCAST_TOTAL":
      return {
        ...state,
        broadcastTotalLast7Days: action.payload
      };

    case "CHART_BROADCAST":
      return {
        ...state,
        chartBroadcastData: action.payload
      };
    case "FETCH_MAXIMUM_MESSAGE":
      return {
        ...state,
        broadcast: action.payload
      };
    case 'FETCH_ACTIVITY_TOP':
      return {
        ...state,
        activityTop: action.payload,
      };
    case 'FETCH_GROUP_CONVERSATIONS': {
      const payload = action.payload || {};
      const summary = Array.isArray(payload.summary) ? payload.summary : [];
      const hourly = Array.isArray(payload.hourly) ? payload.hourly : [];
      const groupConversationsTotal = summary.reduce((s, r) => s + (+r.total || 0), 0);

      return {
        ...state,
        groupConversations: payload,
        groupConversationsRangeKey: action.meta?.rangeKey,
        groupConversationsTotal,
        groupConversationsHourlyTotal: hourly.reduce((s, r) => s + (+r.total || 0), 0),
      };
    }

    case 'DASHBOARD_SET_PERIOD':
      return {
        ...state,
        period: action.payload,
      };
    default:
      return state
  }
}
